import { postData } from "../services/api";
import { FlowDataHash } from "./Definations";
import ApiResponse from "../types/IApiResponse";
import handleApiResponse from "../utils/handleApiResponse";
import hash from "object-hash";

export const fetchFlowDataV1 = async (
  startLoading: () => void,
  stopLoading: () => void,
  seasonId: number,
  teamId: number,
  isForMatch: boolean,
  matchId: number,
  compareWithSeasonAverage: boolean,
  setFlowData: any
) => {
  startLoading();

  const query = {
    seasonId: seasonId,
    teamId: teamId,
    isForMatch: isForMatch,
    matchId: matchId,
    compareWithSeasonAverage: compareWithSeasonAverage,
  };

  const response: any= await postData(
    "https://machinefootballwebapi.azurewebsites.net/PassNetwork/GetPassesByTeamSeasonId",
    {
      seasonId: seasonId,
      teamId: teamId,
      isForMatch: isForMatch,
      matchId: matchId,
      compareWithSeasonAverage: compareWithSeasonAverage,
    }
  );

  stopLoading();
  setFlowData({ hash: hash(query), response });
};
